<template>
  <div class="questionnaires-tab">
    <SubpanelTable
      v-if="tableTitle && tableList && tableList.length"
      :tableColumns="tableTitle"
      :tableData="tableList"
      @rowClick="openQuestionnaires"
      subpanelName="questionnaires"
      style="min-height: 200px"
    ></SubpanelTable>
    <div v-else>
      <Alert text="Анкеты еще не были добавлены" />
    </div>
  </div>
</template>
<script>
import { mixin } from '@/utils/mixins';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import Alert from 'Elements/Alert/Alert';

export default {
  mixins: [mixin],
  props: {
    metadata: [Array, Object]
  },
  data() {
    return {
      tableTitle: null,
      tableList: null,

      candidateId: '',
      deleteDialogWidth: null
    };
  },
  created() {
    if (this.metadata.data && this.metadata.data.title) {
      this.tableTitle = this.metadata.data.title;
    }
    if (this.metadata.data && this.metadata.data.List) {
      this.tableList = this.metadata.data.List;
    }
  },
  methods: {
    openQuestionnaires(item) {
      let url = `?index.php&module=LKK_CANDIDATE_QUESTIONNAIRE&action=DetailView&record=${
        item?.id?.value || ''
      }`;

      let route = this.$router.resolve({
        name: '*',
        params: {
          url
        }
      });
      window.open(route.href, '_blank');
    }
  },
  components: {
    SubpanelTable,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.questionnaires-tab {
  padding: 16px 24px 24px;
  background: $white;
  border-radius: 4px;
}
</style>
